import styled from 'styled-components';

import { TOP_BAR_HEIGHT } from '../../constants';

export const BoardTopBar = styled.div`
  min-height: ${TOP_BAR_HEIGHT}px;
  height: ${TOP_BAR_HEIGHT}px;
  border-bottom: 1px solid var(--color-border-secondary);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  background-color: var(--color-bg-primary);
`;

export const BoardFilterBar = styled.div<{ hasBorder?: boolean }>`
  min-height: ${TOP_BAR_HEIGHT}px;
  height: ${TOP_BAR_HEIGHT}px;
  padding: 0px 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  border-bottom: ${(props) =>
    props.hasBorder ? `1px solid var(--color-border-secondary)` : 'unset'};
`;

// Bounds the quick filter row so a long list can't widen the board and push
// the grid off screen. `contain: inline-size` stops the pills' width
// propagating up to ancestor flex items that lack `min-width: 0`.
export const BoardQuickFilterBounds = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  contain: inline-size;
`;

export const BoardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const BoardMainContent = styled.div<{
  isWorkSpace: boolean;
  hasQuickFilters: boolean;
}>`
  flex: 1;
  padding: 0px 24px 16px 24px;
  overflow: hidden;
`;
